import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js'
import './nlp/tabler.css';
import './panel.css';
// import './jquery-simple-upload.css';
// import '@kanety/jquery-simple-upload';

function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring( o ){ return typeof(o) == 'string';}
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig,'').toLowerCase() }
function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return false;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

function sbool( v )
{
	return ['No','Yes'][v];
}

var companyList = [];
function getCompanies( callback )
{
	if( companyList.length ) callback( companyList )
	window.post( 'find_companies', {match:{active:true}}, function(res){
		if( res.status ) companyList = res.data.records;
		console.log( 'companyList', companyList );
		callback( companyList );
	})
}

var tabDs = null;

function formatProject( a ) {
    var cn = 'd-project';
    var name = a.datasetProjectName;
    if( !name ) {
        name = '(select project)';
        cn += ' not-selected'
    }
    return '<div class="'+cn+'" data-id="'+a.datasetId+'">' + name + '</div>';
}

function selectProject( ev ) {
    var datasetId = $(this).attr('data-id');
    console.log( datasetId )
    var a = tabDs.rows.find( r => r.data.datasetId == datasetId ).data;
    console.log( a )
    frm.myAlert( a.datasetName, '<div class="not-selected">(loading projects)</div>', 'Cancel' );
    var useTags = (tabDs.descriptor.extra || {}).useTags !== false;
    var dts = {id:datasetId, version: a.datasetVersions.length-1};
    // if( useTags ) dts.tag = Object.keys( tabDs.descriptor.filters.tags || {})
    console.log( 'dts', dts )
    probe( dts, (res) => {
        if( !res.datasetProjects.length ) {
            $('.modal-body').html('This project has no classification projects');
            $('.modal-close').html('Close')
            return;
        }
        console.log( 'PROBE', res )
        $('.modal-body').html('<div class="d-select"></div>');
        $('.d-select').css({height:350});

        var opts = clone(res.datasetProjects);
        opts.unshift({value:'',label:''})
        var dproj = frm.dropDown($('.d-select'), opts, null, {width:'100%', placeholder: 'Select Project'}, function(v){
            if( v == '') return;

            var dn = res.datasetProjects.find( d => d.value == v ).label;
            console.log( 'SELECT', v, dn )
            a.datasetProject = v;
            a.datasetProjectName = dn;
            frm.myAlertClose();
            tabDs.draw();

        }).addClass('adl-dropdown');
        
        setTimeout( function(){
            
        dproj.find('button')[0].click();
        },100)
    })
}

function getDatasets( company, type, callback )
{

    
    var global = window.GlobalVars;
    // let dtypes = {
    //     'NER': ['Text','PDF'],
    //     'TEXT_QA': ['Text'],
    //     'Comprehend NER': ['PDFOCR', 'PDFImage'],
    //     'OCR': ['PDFOCR', 'PDFImage'],
    //     'Bulk Image Classification': ['Image'],
    //     'Classification': ['Image', 'Text','PDF', 'Video'],
    //     'Pose Estimation': ['Image'],
    //     'Media Transcription':['Video','Audio'],
    //     'Segmentation':['Image'],
    // }

    let projectTypeCheck = window.GlobalVars.PDFProjectTypeCheck;
    let projecttype = window.GlobalVars.PDFProjectType;

    let dtypes;

    if (projectTypeCheck === "Computer Vision" && projecttype === "Classification") {
        dtypes = {
            'Classification': ['Video', 'Audio','Image']
        };
    } 
    else if(projectTypeCheck === "Audio" && projecttype === "Media Transcription"){
        dtypes = {
            'Media Transcription': ['Audio'],
        }
    }
    else {
        dtypes = {
            'NER': ['Text', 'PDF'],
            'TEXT_QA': ['Text'],
            'Content Generation': ['Image'],
            'Comprehend NER': ['PDFOCR', 'PDFImage'],
            'OCR': ['PDFOCR', 'PDFImage'],
            'Bulk Image Classification': ['Image'],
            'Classification': ['Text', 'PDF'],
            'Pose Estimation': ['Image'],
            'Media Transcription': ['Video'],
            'AmEx Audio Templete': ['Audio'],
            'Code Switching': ['Audio'],
            'Segmentation': ['Image'],
            'Key Point': ['Image'],
            'Response Generation':['Csv']
        };
    }


    window.post('find_datasets',{match:{company:company,datasetType:{$in:dtypes[type]}}}, function(res){
        var dsList = [];
        if( res.status ) dsList = res.data.records;
        // console.log( 'dsList', dsList );
        var datasets = res.data.records;
        function listTags(v,lastV) {
            for( var k in v ) v[k].label = k;
            var ret = Object.values(v);
            ret.sort( (a,b) => a.count-b.count );
            return ret.map( i => i.label )
        }
        // return;
        var desc = {
            title: 'Select datasets to add to project',
            columns: {
                datasetName: 'Name',
                companyName: 'Company',
                metadata: 'Metadata',
                tags: 'Tags',
                dProject: 'Project',
                s_datasetType: 'Type',
                items: 'Items',
            },
            filter: true,
            search: true,
            sort: true,
            initialSort: 'modified',
            initialSortDir: -1,
            pageSize: 4,
            noFilter: {
                modified:1,
            },
            noSort: null,
            centerCol: ['modified','active'],
            format: tabler.formatString,
            forceType: {
                numProjects:1,
                items:1,
                modified: 1,
            },
            colWidth: {
                name: 30,
            },
            formatCol:{
                modified: tabler.formatTimeAgoSec,
                active: tabler.formatActive,
                metadata: frm.smallerText,
                tags: frm.smallerText,
                dProject: formatProject,
            },
            maxLinesCol: {
                metadata: 4,
                tags: 4,
            },
            selectMode: true,
            selectId: 'datasetId',
            clickCol: ['none'],
        }
        if( !project.training ) delete desc.columns.dProject;
        if( !window.hasPriv('admin')) delete desc.columns.companyName;
        desc.columns.modified = 'Updated';
        // desc.columns.active = 'Active'
        console.log( 'DESCll', desc )
        var ctx = 'dataset_select_'+global.PDFProjectId;
        console.log('ctxx', ctx)
        var tab = tabler.table($('#datasetsearch'), desc, ctx );
        console.log( 'tabseach', tab )
        tab.onSelect( checkSelected )
        window.tabDs = tabDs = tab;
        tabDs.onUpdate( checkSelected );
        datasets.forEach( a => {
            console.log( 'AAA', a.datasetName, a.projectVersions )
            if( project.training && (!a.projectVersions || Object.keys(a.projectVersions).length == 0)) return;
            if( a.tags ) a.tags = listTags(a.tags)
            a.dProject = a;
            if( a.metadata ) {
                var md = [];
                for( var k in a.metadata ) md.push( k+':'+a.metadata[k])
                a.metadata = md;
            }
            a.versionCount = a.datasetVersions.length;
            a.s_datasetType = window.DatasetTypes[a.datasetType]
            tab.addRow(a, function( col, row ){
                console.log( 'tabler clickkkkk', col, row, row[col] )
                var p = row;
                window.GlobalVars.currentDatasetId = p.datasetId;
                window.GlobalVars.currentDataset = p;
                // tabler.clearCtx(ctx);
                window.saveSession( function(){
                    // window.goPage('nlpBrowse');
                    window.goPage('datasetItems');
                });
            })
        });
        tab.onDraw( () => {
            $('.d-project').css({cursor:'pointer'}).on('click', selectProject )
        })
        window.ttt = tab;
        tab.draw();
        checkSelected();
        $('#addselected').on('click', addSelected )
        var useTags = (tabDs.descriptor.extra || {}).useTags !== false;
        $('#usefiltertags').prop('checked', useTags ).on('change', function(){
            if( !tabDs.descriptor.extra ) tabDs.descriptor.extra = {};
            tabDs.descriptor.extra.useTags = $(this).prop('checked')
            tabDs.saveContext();
        });
        callback( dsList );
    })
}

function addSelected() {
    var selected = tabDs.descriptor.selected;
    var useTags = $('#usefiltertags').prop('checked') == true;
    var ds = [];
    var dsVisible = {};
    for( var d of tabDs.baseRows ) dsVisible[d.data.datasetId] = 1;
    for (var d of tabDs.rows) {
        if (selected[d.data.datasetId]) {
            var v = d.data.datasetVersions.length - 1;
            var it = { id: d.data.datasetId, version: v };
            if( !dsVisible[d.data.datasetId] ) continue;
            if (d.data.datasetProject) it.datasetProject = d.data.datasetProject;
            if (useTags && tabDs.descriptor.filters.tags && d.data.tags ) {
                it.tag = Object.keys(tabDs.descriptor.filters.tags).filter( t => d.data.tags.indexOf(t) >= 0 );
                if( it.tag == 0 ) continue;
            }
            ds.push(it)
        }
    }
    frm.loading( 'Adding')
    frm.runAll(ds, (d, next) => {
        addDataset(d, next)
    }, () => {
        getProjectDatasets();
        tabDs.saveContext();
        tabDs.draw();
        frm.loadingOut()
    })
    console.log('datasets to add', ds)
}

function checkSelected(){
    if( !tabDs ) return;
    var selected = 0;
    for( var d of tabDs.baseRows ) if( tabDs.descriptor.selected[d.data.datasetId] ) selected++;
    // var selected = Object.keys( tabDs.descriptor.selected );
    console.log( 'CHECK SELECTED', selected )
    $('#addselected').attr('disabled', selected.length == 0 ).html('Add Selected Datasets ('+selected+')')
}

var datasetAdding = false;

function addDataset( dts, callback ) {
    var global = window.GlobalVars;

    console.log( 'DTS', dts, project.training )
    if( project.training && !dts.datasetProject ) {
        datasetAdding = false;
        frm.myAlert('Add Error','You must select the Dataset classification project', 'Ok');
        if( callback ) return callback();
        return;
    } 
    window.post('add_project_datasets', {
        project:global.PDFProjectId,
        datasetId:dts.id,
        version:dts.version,
        tag:dts.tag,
        datasetProject:dts.datasetProject,
        itemIds:dts.itemIds,
        timeStamp: getmsec(),
    }, res => {
        console.log( 'RES', res )
        var r = res.data;
        if( r.status == 0 ) return frm.myAlert('Add Error', r.value, 'Ok', function(){ frm.loadingOut(); if( callback ) callback(); } );
        delete tabDs.descriptor.selected[dts.id]
        if( callback ) callback();
        else getProjectDatasets()
    })
}

function delDataset( row, el ) {
    var global = window.GlobalVars;
    console.log( 'DEL', row, el )
    function del( probe, callback ) {
        window.post('del_project_datasets', {
            project: global.PDFProjectId,
            datasetId: row.id,
            version: row.version,
            probe: probe,
            tag: row.tag,
            datasetProject: row.datasetProject,
            itemIds:row.itemIds,
            note: row.note,
        }, res => {
            var r = res.data;
            callback(r)
        });
    }
    del( true, async r => {
        console.log( 'DELPROBE', r )
        if( r.status == 0 ) return frm.myAlert('Delete Error', r.value, 'Ok' );
        if( r.del > 0 ) {
            var items = r.del > 1 ? 'items' : 'item';
            let conf = await frm.myConfirm( 'Delete warning', 'Deleting this dataset-versions will remove <b>'+r.del+'</b> '+items+' from the project. If you are sure, please type <b>delete</b> in the input box.', 'delete', 'Delete', 'Cancel' );
            if( conf ) del( false, getProjectDatasets );
            // frm.myAlert( 'Delete warning', 'Deleting this dataset-versions will remove <b>'+r.del+'</b> '+items+' from the project. If you are sure, please type <b>delete</b> in the input box.<br><input placeholder="type \'delete\' to confirm deletion" type="text" id="confirm_delete" autocomplete="off" class="mb-4 form-control">', 'Ok', ckDel, 'Cancel')
            // function ckDel(ev) {
            //     if( $('#confirm_delete').val().trim().toLowerCase() == 'delete' ) {
            //         frm.myAlertClose()
            //         del( false, getProjectDatasets )
            //     }
            //     else {
            //         $('#confirm_delete')[0].focus();
            //         ev.preventDefault();
            //         ev.stopPropagation();
            //     }
            // }
            // function ckDis() {
            //     var dis = $('#confirm_delete').val().trim().toLowerCase() != 'delete'
            //     $('#modal-close').attr('disabled', dis )
            // }
            // $('#confirm_delete').on('keyup', (ev) => {
            //     if( ev.keyCode == 13 ) ckDel(ev);
            //     ckDis();
            // })
            // ckDis();
            // setTimeout( function(){
            //     $('#confirm_delete')[0].focus()
            // },500 )
        }
        else del( false, getProjectDatasets )
    })
}


function getProjectDatasets() {
    var global = window.GlobalVars;

    // var match = {id:global.PDFProjectId};
    // window.post( 'find_projects', {match:match}, function(pres){
    //     project = pres.data.records[0];
    //     console.log( 'project', project )
    //     window.post('find_project_datasets',{match:{project:global.PDFProjectId}}, res => {
    //         projectDatasets = (res.data && res.data.records) || [];
    //         console.log( 'PROJECTDatasets', projectDatasets )
    //         draw();
    //         datasetAdding = false;
    //     })
    // });

    window.post('find_project_datasets',{match:{project:global.PDFProjectId}}, res => {
        projectDatasets = (res.data && res.data.records) || [];
        console.log( 'PROJECTDatasets', projectDatasets )
        draw();
        datasetAdding = false;
    })
}

function probe( dts, callback, ignore ) {
    var global = window.GlobalVars;
    window.post('probe_project_datasets', {
        project: global.PDFProjectId,
        datasetId: dts.id,
        version: dts.version,
        tag: dts.tag || '',
        datasetProject: dts.datasetProject || '',
    }, res => {
        var r = res.data;
        callback(r, ignore)
    });
}

function error( s ) {
    var err = $('<div role="alert" class="fade alert alert-danger show">').html(s);
    $('.feedback').html('').append(err)
}

var drawn = false;
var datasets = null;
var datasetObj = {};
var projectDatasets = null;
var project = null;
var draw = null;
function DatasetSelect(prop) {

    var global = window.GlobalVars;
    var tab;

	if( !global.PDFProjectCompany ) global.PDFProjectCompany = global.userCompany;
	global.currentFileDataset  = [global.PDFProjectCompany,global.PDFProjectId,global.PDFProjectName].join('|');
	var [dataSetCompany,dataSetId,dataSetName] = global.currentFileDataset ? global.currentFileDataset.split('|') : [null,null,null];


    function drawAddDataset(){
        var addDts = {};
        var addVersion = {};
        var dver = null;
        var dtag = null;
        var dproj = null;

        var alist = $('.addlist');
        var opts = datasets.map( d => { return {value:d.datasetId,label:d.datasetName}});
        // opts.unshift({value:'',label:'&nbsp;'});
        var first = true;
        function dig3(v){ return v.toString().padStart(3,'0')}
        var dset = frm.dropDown(alist, opts, null, {width:250, placeholder: 'Select Dataset'}, function(v){
            if( addDts.id != v ) {
                if( first ) { first = false; return }
                addDts.id = v;
                addDts.version = '';
                if( v == '') var versions = [];
                else {
                    // var versions = datasetObj[v].datasetVersions.map( i => { return {value:i.id,label:dig3(i.id) + ' - ' + i.name + ' - ' + tabler.formatTimeAgoSec(i.modified)+ ' ago'}} ).reverse();
                    var versions = datasetObj[v].datasetVersions.map( i => { return {value:i.id,label: i.name + ' - ' + tabler.formatTimeAgoSec(i.modified)+ ' ago'}} ).reverse();
                }
                console.log( versions )
                // versions.unshift({value:'',label:'&nbsp;'});
                if( dver ) {
                    var vsel = versions.length > 1 ? '' : versions[0].value.toString();
                    console.log( 'versions', versions, vsel )
                    dver.setOptions( versions, vsel );
                }
                // redraw();
            }
        } ).addClass('adl-dropdown');
        dver = frm.dropDown(alist, [], null, {width:250, placeholder: 'Select Version'}, function(v){
            if( addDts.version === v ) return;
            addDts.version = v;

            var dts = clone(addDts );
            dts.tag = '';
            dts.datasetProject = '';
            probe( dts, setTagProj )
        }).addClass('adl-dropdown');

        dtag = frm.dropDown(alist, [], null, {width:250, placeholder: 'Optional Filter Tag'}, function(v){
            if( addDts.tag === v ) return;
            addDts.tag = v;
            var dts = clone(addDts );
            dts.datasetProject = '';
            probe( dts, setTagProj, 'tag' )
        }).addClass('adl-dropdown');

        if( project.training ) {
            dproj = frm.dropDown(alist, [], null, {width:250, placeholder: 'Dataset Classification Proj.'}, function(v){
                if( addDts.datasetProject === v ) return;
                addDts.datasetProject = v;
                var dts = clone(addDts );
                dts.tag = '';
                probe( dts, setTagProj, 'datasetProject' )
            }).addClass('adl-dropdown');
        }

        function setTagProj( data, ignore ) {
            var tagList = data.tags;
            tagList.unshift({value:'',label:'&nbsp;'})
            if( ignore != 'tag' ) dtag.setOptions( tagList, addDts.tag );
            var projList = data.datasetProjects;
            tagList.unshift({value:'',label:'&nbsp;'})
            if( ignore != 'datasetProject' && dproj ) dproj.setOptions( projList, addDts.datasetProject )
        }

        var addBtn = $('<button>').addClass('btn btn-primary').html('Add Dataset').on('click', function(){
            if( !addDts.id ) return frm.myAlert('Invalid Dataset', 'Please select a Dataset', 'Ok')
            if( addDts.version === '' ) return frm.myAlert('Invalid Version', 'Please select a Dataset Version', 'Ok')
            if( datasetAdding ) return;
            datasetAdding = true;
            addDataset( addDts );
        })
        alist.append( addBtn )
    }


	draw = function()
	{
        $('.feedback').html('');
        $('.addlist').html('');
        $('#datasetlist').html('');
        
        console.log( 'DATASETS', datasets )
        drawAddDataset()
        $('.maincontent').append('<div class="wizzbtn">');
		if( !drawn ) if( !window.GlobalVars.PDFProjectActive ) window.wizzardButtons( $('.wizzbtn') );
        drawn = true;


        var desc = {
			title: 'Project Datasets',
			columns: {
				description: 'Description',
                tag: 'Tag',
                datasetName: 'Dataset Name',
                timeStamp: 'Timestamp',
			},
			filter: true,
			search: true,
			sort: true,
			pageSize: 10,
			noFilter: null,
			noSearch: null,
			noSort: null,
			clickCol: 'delete',
			noFilter: 'delete',
			noSort: 'delete',
			// centerCol:'delete',
			format: tabler.formatString,
            formatCol:{
                tag: frm.smallerText,
            },
			centerCol: true,
		}
        if( project.training ) {
            desc.columns.datasetProjectName = 'Dataset classificatoin Proj.'
        }
        desc.columns.delete = '';
		var tab = tabler.table($('#datasetlist'), desc, 'projectdataset' );
        // console.log( 'datasetList', tab )
        console.log('prjt', projectDatasets)
		projectDatasets.forEach( d=> {
            // console.log('dpd', d)
            // console.log( 'DDD', d.datasetId, datasetObj[d.datasetId], datasetObj );
            // var dname = d.datasetName || 'Item selection';
            var dname;
            if( d.itemIds ) {
                var description;
                // console.log('lgn', d.itemIds.length)
                if(d.itemIds.length > 1) dname = d.itemIds.length + ' items have been added ';
                else dname = d.itemIds.length + ' item has been added ';
                description = dname;
                // if( d.note ) dname += ' "' + d.note + '"'
            } 
            else {
                // console.log( 'datasetObj', datasetObj, d.datasetId )
                // console.log( 'has datasetID', d.datasetId, datasetObj[d.datasetId] )
                var description = dname + ' ('+d.datasetVersionName+')';
                if( !d.datasetVisible ) description += ' <i>Dataset Deleted</i>';
                // var description = 'hello';
            }
            console.log('dyt', d)
            var a = {
                id:d.datasetId,
                version: d.datasetVersion,
                description: description,
                // name:datasetObj[d.datasetId].datasetName, 
                // versionName:datasetObj[d.datasetId].datasetVersions[d.datasetVersion].name,
                tag: d.tag,
                datasetProject: d.datasetProject,
                datasetProjectName: d.datasetProjectName,
                datasetName: d.datasetName,
                timeStamp: new Date(d.timeStamp).toLocaleString(),
                itemIds: d.itemIds,
                note: d.note,
                delete:'<i class="fa fa-times-circle fa-lg worker-del"></i>',
            }
            // console.log('aaaaaaaaaaaaaaaaaaaaa', a)
			tab.addRow(a, function( col, row, el ){
				delDataset( row, el );
			})
		});
        console.log( 'tab', tab )
		tab.draw();
	}



    useEffect( function(a){
        var match = {id:global.PDFProjectId};
        window.topBarVisible()


        $('#addswitch').on('click', ()=>{
            $('.addcontrols').show();
            $('#datasetsearch').show();
            $('#addswitch').hide();
        })

        if(window.GlobalVars.userCurrentRole.priv .includes("c_super")) {
            $('#globalSearch').hide();
        }

        $('#globalSearch').on('click', ()=>{
            window.goPage('datasetAdvanced');
        })
        window.post( 'find_projects', {match:match}, function(pres){
            project = pres.data.records[0];
            console.log( 'project', project )
            getDatasets(global.PDFProjectCompany, project.type, (d) => {
                datasets = d;
                for( var d of datasets ) datasetObj[d.datasetId] = d; 
                console.log( 'datasetObj', datasetObj )
                getProjectDatasets();
            } )
        });



    });

    return (
        <>
            <div fluid="md p-0" className="maincontent project-panel">
                <div className="feedback"></div>
                <div className="project-section">
                    <div className="addlist hidden">
                    </div>
                    <button className="btn btn-primary inline-flex mr-3 mt-2" id="addswitch"><i class="fa fa-plus mr-2 mt-1"></i>Add Datasets</button>
                    <div className="addcontrols hidden">
                    <h1>Select Datasets to be used in project</h1>
                        <button className="btn btn-primary inline-flex mr-3" id="addselected" disabled>Add Selected Datasets</button>
                        <div className="form-check inline-flex">
                            <input className="form-check-input pointer" type="checkbox" value="" id="usefiltertags"/>
                                <label className="form-check-label unselectable pointer" for="usefiltertags">
                                    Select items by filtered tags
                                </label>
                        </div>
                        <Button id="globalSearch" variant="primary" type="submit" style={{float:'right'}}class="ml-4 mt-2 btn btn-pink"><i class="fa fa-search mr-2" aria-hidden="true"></i>Global Search</Button>
                    </div>
                    <Table id="datasetsearch" bordered hover size="sm" className="table-grid mt-3 hidden">
                    </Table>
                    <Table id="datasetlist" bordered hover size="sm" className="table-grid mt-3">
                    </Table>
                </div>
            </div>
        </>
    )
}

export default DatasetSelect
